import React, { Component } from 'react';
import { withStyles } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import {  Cookies } from 'react-cookie';
import Phonebook from "./PhoneBook";
import Phonebookusers from "./Phonebookusers";

// import PotentialCustomers from "./PotentialCustomers";
import CurrentCustomers from "./CurrentCustomers";
import RenewalInsurance from "./RenewalInsurance";
import CurrentRenewalInsurance from "./CurrentRenewalInsurance";
import PotentialOilCustomers from "./PotentialOilCustomers";

import LastYearCurrentCustomers from "./LastYearCurrentCustomers";
import AllPrimarySmsRequests from "./AllPrimarySmsRequests";
import MyPrimarySmsRequests from "./MyPrimarySmsRequests";




const styles = theme => ({
    paperrtl: {
        marginTop: theme.spacing(0),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    }
    , paper: {
        display: 'flex',
        flexWrap: 'wrap',
        '& > *': {
            margin: theme.spacing(1),
            width: theme.spacing(20),
        },
    },


});

class ChangeSmsReceiver extends Component {
    cookies=new Cookies();
    constructor(props) {
        super(props);
        this.state = {
            value:0,
        }}

    componentDidMount() {

    }
    handleChange= (event,newValue) => {
        this.setState({ value:newValue });
    }
    render() {
        const { classes } = this.props;
        const { value } = this.state;

        return (
            <div>
                <AppBar position="sticky"color="primary" >

                    <Tabs
                        style={{height:'60px',textAlign:'center'}}
                        value={value}
                        onChange={this.handleChange}
                        indicatorColor="secondary"
                        textColor={'#000000'}
                        variant="scrollable"
                        scrollButtons="auto"
                        aria-label="scrollable auto tabs example"
                    >
                        {/*<Tab label="sodor"  />*/}
                        {/*<Tab label="new2"  />*/}
                        {/*<Tab label="new"  />*/}
                        <Tab label="مشتری های قدیمی(من)"  />
                        <Tab label="مشتری های قدیمی"  />
                        <Tab label="مشتری های جاری"  />
                        <Tab label="تمدیدی های من (جاری)"  />
                        <Tab label="لیست بیمه نامه های من"  />
                        <Tab label="لیست بیمه نامه های کارمندان"  />
                        <Tab label="مشتری های جاری1404"  />



                    </Tabs>


                </AppBar>

                {/*{(value===0)?<PotentialPrimaryCustomers  props={this.props}/>:null}*/}

                {/*{(value===3)?<DoctorsCustomers  props={this.props}/>:null}*/}
                {/*{(value===4)?<DoctorCustomersMessages  props={this.props}/>:null}*/}
                {/*{(value===4)?<TreatmentCustomers  props={this.props}/>:null}*/}
                {/*{(value===0)?<IssuanceCurrentRequests  props={this.props}/>:null}*/}
                {/*{(value===1)?<PaidMyCurrentRequests  props={this.props}/>:null}*/}
                {/*{(value===2)?<Shah  props={this.props}/>:null}*/}
                {(value===0)?<MyPrimarySmsRequests  props={this.props}/>:null}
                {(value===1)?<AllPrimarySmsRequests  props={this.props}/>:null}
                {(value===2)?<CurrentCustomers  props={this.props}/>:null}
                {(value===3)?<CurrentRenewalInsurance  props={this.props}/>:null}
                {(value===4)?<Phonebook  props={this.props}/>:null}
                {(value===5)?<Phonebookusers  props={this.props}/>:null}
                {(value===6)?<LastYearCurrentCustomers  props={this.props}/>:null}





            </div>
        );
    }
}

export default  withStyles(styles)(ChangeSmsReceiver);
